// header mega menu hover script Start

document.addEventListener("DOMContentLoaded", () => {
  const items = document
    .querySelector(".header__inline-menu")
    .querySelectorAll("details");

  items.forEach((item) => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
    });

    item.addEventListener("mouseleave", () => {
      setTimeout(() => {
        if (
          !item.matches(":hover") &&
          !item.querySelector("ul").matches(":hover")
        ) {
          item.removeAttribute("open");
        }
      }, 200);
    });

    item.querySelector("ul").addEventListener("mouseleave", () => {
      setTimeout(() => {
        if (
          !item.matches(":hover") &&
          !item.querySelector("ul").matches(":hover")
        ) {
          item.removeAttribute("open");
        }
      }, 200); 
    });
  });
});

// header mega menu hover script End

/*------- Card product variant change script start--------*/

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".card-product-variants").forEach((variantContainer) => {
    
    // function updateProductImage(variantElement) {
    //   let variant = JSON.parse(variantElement.dataset.variant);
    //   if (variant.featured_image) {
    //     let imgElement = variantContainer.closest(".card").querySelector(".card__inner .card__media .media img");
    //     if (imgElement) {
    //       imgElement.src = variant.featured_image.src + "&width=533";
    //       imgElement.srcset = `
    //         ${variant.featured_image.src}&width=165 165w,
    //         ${variant.featured_image.src}&width=360 360w,
    //         ${variant.featured_image.src}&width=533 533w,
    //         ${variant.featured_image.src}&width=720 720w,
    //         ${variant.featured_image.src}&width=940 940w,
    //         ${variant.featured_image.src}&width=1066 1066w,
    //         ${variant.featured_image.src} 1080w
    //       `;
    //     }
    //   }
    // }
    function updateProductImage(variantElement) {
  let variant = JSON.parse(variantElement.dataset.variant);
  let card = variantContainer.closest(".card");
  let imgElement = card.querySelector(".card__inner .card__media img");

  if (variant.featured_image && imgElement) {
    let imageUrl = variant.featured_image.src;

    // Remove existing query string if any
    imageUrl = imageUrl.split('?')[0];

    imgElement.src = `${imageUrl}?width=533`;
    imgElement.srcset = `
      ${imageUrl}?width=165 165w,
      ${imageUrl}?width=360 360w,
      ${imageUrl}?width=533 533w,
      ${imageUrl}?width=720 720w,
      ${imageUrl}?width=940 940w,
      ${imageUrl}?width=1066 1066w,
      ${imageUrl} 1080w
    `;
  }
}

    function updateProductDetails(variantElement) {
      let cardElement = variantContainer.closest(".card");
      let priceElement = cardElement.querySelector(".price-item--regular");
      let salePriceElement = cardElement.querySelector(".price-item--sale");
      let compareAtPriceElement = cardElement.querySelector(".price__sale-main s");
      let discountElement = cardElement.querySelector(".ct-saev-main");
      let subscriptionElement = cardElement.querySelector(".variant-has-subscription");
      let checkPriceElement = cardElement.querySelector(".price");
      
      let price = variantElement.dataset.variantPrice;
      let compareAtPrice = variantElement.dataset.variantCompareAtPrice;
      let hasSubscription = variantElement.dataset.variantSubscription === "true";

      if (priceElement) priceElement.textContent = price;

      if (compareAtPrice && compareAtPrice !== price) {
        if (salePriceElement) salePriceElement.textContent = price;
        if (compareAtPriceElement) compareAtPriceElement.textContent = compareAtPrice;
        // if (discountElement) {
        //   let originalPrice = parseFloat(compareAtPrice.replace(/[^0-9.]/g, ""));
        //   let newPrice = parseFloat(price.replace(/[^0-9.]/g, ""));
        //   let discount = Math.ceil(((originalPrice - newPrice) / originalPrice) * 100);
        //   discountElement.textContent = `${discount}% off`;
        // }
        if (discountElement) {
          let originalPrice = parseFloat(compareAtPrice.replace(/[^0-9.]/g, ""));
          let newPrice = parseFloat(price.replace(/[^0-9.]/g, ""));

          if (!isNaN(originalPrice) && !isNaN(newPrice) && originalPrice > newPrice) {
            let discount = ((originalPrice - newPrice) / originalPrice) * 100;
            discountElement.textContent = `${discount.toFixed(1)}% off`;
          } else {
            discountElement.textContent = ""; // No discount
          }
        }
        if (checkPriceElement) {
          checkPriceElement.classList.add("price--on-sale");
        }
        
      } else {
        if (compareAtPriceElement) compareAtPriceElement.textContent = "";
        if (discountElement) discountElement.textContent = "";
        if (checkPriceElement) {
          checkPriceElement.classList.remove("price--on-sale");
        }
      }

      subscriptionElement.style.display = hasSubscription ? "block" : "none";
    }

    function updateVariantSelection(variantElement) {
      let cardElement = variantContainer.closest(".card");
      let variantIdInput = cardElement.querySelector(".product-variant-id");
      let addToCartButton = cardElement.querySelector(".quick-add__submit");
      let variant = JSON.parse(variantElement.dataset.variant);

      if (variantIdInput) {
        variantIdInput.value = variant.id;
        variantIdInput.disabled = !variant.available;
      }

      if (addToCartButton) {
        if (variant.available) {
          addToCartButton.removeAttribute("disabled");
        } else {
          addToCartButton.setAttribute("disabled", "true");
        }
      }
    }

    function handleVariantSelection(variantElement) {
      variantContainer.querySelectorAll(".variant-option").forEach(v => v.classList.remove("variant-active"));
      variantElement.classList.add("variant-active");
      updateProductImage(variantElement);
      updateProductDetails(variantElement);
      updateVariantSelection(variantElement);
    }

    let defaultVariant = variantContainer.querySelector(".variant-option.variant-active");
    if (defaultVariant) {
      handleVariantSelection(defaultVariant);
    }

    variantContainer.querySelectorAll(".variant-option").forEach((variantOption) => {
      variantOption.addEventListener("click", function () {
        handleVariantSelection(this);
      });
    });
  });
});


/*------- Card product variant change script End--------*/


// ------- product page add to cart button sticky ------

// The scroll handler below used to read getBoundingClientRect() and offsetHeight on
// every single scroll event, and then write classes based on what it read. Reading
// layout after a write forces the browser to re-run layout synchronously mid-scroll -
// Lighthouse reported this page as having forced reflow. On a long product page that
// is a layout pass per scroll event, which is felt directly as scroll jank and counts
// against INP.
//
// Three changes, no behavioural difference:
//   - the listener is passive, so the browser never waits on it before scrolling;
//   - the work is throttled into one requestAnimationFrame, so at most one run per
//     frame no matter how many scroll events arrive;
//   - the layout reads are cached and only refreshed on resize, rather than being
//     repeated for values that do not change while scrolling.
document.addEventListener("DOMContentLoaded", () => {
  const addToCartWrapper = document.querySelector(".add-to-cart-wrapper");
  const footer = document.querySelector("footer");
  const header = document.querySelector("header");  // Get the header
  if (!addToCartWrapper || !footer || !header) return;

  const buffer = 20;  // Button fixes slightly before reaching the header
  let originalPosition = 0;
  let footerOffset = 0;
  let headerHeight = 0;
  let ticking = false;

  // All layout reads happen here, batched, and never interleaved with class writes.
  const measure = () => {
    const wasFixed = addToCartWrapper.classList.contains("fixed-bottom");
    // Measuring while the element is pinned would report the pinned position, so read
    // its resting position with the class off, exactly as the original code did on load.
    if (wasFixed) addToCartWrapper.classList.remove("fixed-bottom");
    originalPosition = addToCartWrapper.getBoundingClientRect().top + window.scrollY;
    if (wasFixed) addToCartWrapper.classList.add("fixed-bottom");

    footerOffset = footer.getBoundingClientRect().top + window.scrollY;
    headerHeight = header.offsetHeight;
  };

  const apply = () => {
    ticking = false;
    const scrollY = window.scrollY;

    // Fix the button just before it goes under the header
    addToCartWrapper.classList.toggle(
      "fixed-bottom",
      scrollY > originalPosition - headerHeight - buffer
    );

    // Stick the button inside the footer
    addToCartWrapper.classList.toggle(
      "at-footer",
      scrollY + window.innerHeight >= footerOffset
    );
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(apply);
  };

  measure();
  apply();

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", () => { measure(); apply(); }, { passive: true });
});



// ------- product page add to cart button sticky ------



// --------------------- search bar animation ------------------

document.addEventListener("DOMContentLoaded", () => {
  const input = document.getElementById("Search-In-Modal");
  if (!input) return;

  const placeholders = [
    'Search "Heart Health"',
    'Search "Immunity Booster"',
    'Search "Liver Tonic"',
    'Search "Stress Relief"'
  ];

  let wordIndex = 0;
  let charIndex = 0;
  let timer = null;
  let running = false;

  const TYPE_SPEED = 100; // ms per char
  const PAUSE_AFTER_WORD = 2000; // ms

  // This animation previously ran forever: a setTimeout chain firing ten times a
  // second, writing input.placeholder each time, for the entire life of the page. It
  // kept waking the main thread long after load, which shows up as main-thread work,
  // keeps the page from ever going idle, and competes with real interactions.
  //
  // It now stops whenever it cannot be seen or would be unwelcome:
  //   - it does not start at all if the visitor prefers reduced motion;
  //   - it pauses when the tab is hidden and when the search box scrolls out of view;
  //   - it stops permanently once the visitor focuses or types in the box, so it can
  //     never fight with what they are typing.
  const reduceMotion =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const typeNextChar = () => {
    if (!running) return;
    const word = placeholders[wordIndex];

    // set substring into placeholder
    input.placeholder = word.slice(0, charIndex);
    charIndex++;

    if (charIndex <= word.length) {
      timer = setTimeout(typeNextChar, TYPE_SPEED);
    } else {
      // finished this word → wait then move to next
      timer = setTimeout(() => {
        charIndex = 0;
        wordIndex = (wordIndex + 1) % placeholders.length;
        typeNextChar();
      }, PAUSE_AFTER_WORD);
    }
  };

  const start = () => {
    if (running || reduceMotion) return;
    running = true;
    typeNextChar();
  };

  const stop = () => {
    running = false;
    clearTimeout(timer);
  };

  // Once the shopper engages with the box, leave it alone for good.
  const stopForever = () => {
    stop();
    input.placeholder = placeholders[0];
    input.removeEventListener("focus", stopForever);
    input.removeEventListener("input", stopForever);
    document.removeEventListener("visibilitychange", onVisibility);
    if (observer) observer.disconnect();
  };

  const onVisibility = () => (document.hidden ? stop() : start());

  let observer = null;
  if (typeof IntersectionObserver === "function") {
    observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => (e.isIntersecting ? start() : stop())),
      { rootMargin: "0px" }
    );
    observer.observe(input);
  } else {
    start();
  }

  document.addEventListener("visibilitychange", onVisibility);
  input.addEventListener("focus", stopForever);
  input.addEventListener("input", stopForever);
});







